diy.angular.registerDirective('diyfmdropfiles', [ 
function() {
    var $ = jQuery;
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {

            var $elem = $(elem);
            
            var getConfig = function() {
                return scope.$eval(attr.diyfmdropfiles);
            }
            
            var config = getConfig();
            if (config === undefined) {
                var unWatch = scope.$watch(getConfig, function(val){
                    config = val;
                    unWatch();
                })
            }
            
            // XXX necesarry trick so that drop of files will function
            $elem.bind('dragover', function(ev) {
                return false;
            });
            
            $elem.bind('drop', function(ev) {
                if (ev.originalEvent.dataTransfer
                    && ev.originalEvent.dataTransfer.files
                    && ev.originalEvent.dataTransfer.files.length > 0)
                {
                    scope.$emit(config.eventName, ev.originalEvent.dataTransfer.files, config.data, undefined, config.source);
                }
                return false;
            }); 
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                config = null;
                attr = null;
            });
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmdropfiles.js
 ** module id = 980
 ** module chunks = 0
 **/